<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row d-print-none">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Detaylı Arama</h4>
            <form class="repeater" @submit.prevent="get">
              <div data-repeater-list="group-a">
                <div class="row">
                  <div class="form-group col-sm-2">
                    <label>Hesap Durumu</label>
                    <v-select v-model="status_id"  :options="status" class="form-control">
                    </v-select>
                  </div>
                  <div class="form-group col-sm-2">
                    <label>Hesap Adı</label>
                    <b-input v-model="account_name"></b-input>
                  </div>
                  <div class="form-group col-sm-2">
                    <label>İBAN</label>
                    <b-input v-model="account_number"></b-input>
                  </div>
                  <div class="form-group col-sm-2">
                    <label>Minimum Yatırım</label>
                    <b-input v-model="min_accept"></b-input>
                  </div>
                  <div class="form-group col-sm-2">
                    <label>Maks. Yatırım</label>
                    <b-input v-model="max_accept"></b-input>
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Email Hesapları</label>
                    <b-form-checkbox switch size="" v-model="mail">
                      <div v-if="mail">Sadece Email Bağlantılı Hesaplar</div>
                      <div v-else>Tüm Hesaplar</div>
                    </b-form-checkbox>

                  </div>
                  <div class="form-group col-sm-2" v-if="mail">
                    <label>Bağlantı Durumu</label>
                    <b-form-checkbox switch size="" v-model="mail_connect">
                      <div v-if="mail_connect === null">Tümü</div>
                      <div v-if="mail_connect === true">Sadece aktif bağlantılar</div>
                      <div v-if="mail_connect === false">Sadece başarısız bağlantılar</div>
                    </b-form-checkbox>
                  </div>
                  <div class="col-lg-2 align-self-center">
                    <b-button-group>
                      <b-button variant="info" type="submit" class="btn-sm"> <i class="fa fa-search" /> Ara</b-button>

                    </b-button-group>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-md-2">
      <div class="col-sm-12 col-md-6">
        <b-button variant="info" v-b-modal.addModal>
          <i  class="fas fa-plus" /> Yeni Hesap Ekle
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class=" float-right">
        </div>
        <div class="row">
          <div class="col-lg-12 flex flex-row flex-wrap items-center gray7 f2">
            <h4>
              <div>
                <b-badge variant="success" class="sites-buttons mr-2" v-for="(item, index) in activatedSites" :key="index" >
                  <div @click="removeActivatedSite({id: item.id})">
                    {{ item.site_name }} <i class="fas fa-times-circle"></i>
                  </div>
                </b-badge>
              </div>
              <div>
                <b-badge class="sites-buttons mr-2" v-for="(item, indexd) in sites" :key="indexd" >
                  <div @click="addActivatedSite({id: item.id})">
                    {{ item.site_name }} <i class="fas fa-plus-circle"></i>
                  </div>
                </b-badge>
              </div>
            </h4>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-header d-flex justify-content-between align-items-center d-print-none">
              İşlemler
              <b-button-group>
              </b-button-group>
            </h5>
            <div class="table-responsive mb-0" id="data">
              <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :busy="loading"
                  show-empty
                  striped
              >
                <template v-slot:table-busy>
                  <div class="text-center text-white my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Yükleniyor..</strong>
                  </div>
                </template>
                <template v-slot:empty="">
                  <b-alert show variant="warning">
                    Kayıt bulunamadı.
                  </b-alert>
                </template>

                <template v-slot:cell(account_name)="data">
                  {{data.item.account_name}}
                  <i class="fas fa-copy" @click="copy(data.item.account_name)"></i>
                  <br>
                  <b-badge v-if="data.item.fast_account" variant="primary" @click="changeFast({status: false, id: data.item.id})">
                    <i class="ion-ios-refresh"></i> FAST HESABI TANIMLI <i class="class"></i>
                  </b-badge>
                  <b-badge v-if="!data.item.fast_account" variant="info" @click="changeFast({status: true, id: data.item.id})">
                    <i class="ion-ios-refresh"></i> FAST HESABI OLARAK TANIMLA <i class="class"></i>
                  </b-badge>

                </template>
                <template v-slot:cell(account_number)="data">
                  {{data.item.account_number}}
                  <i class="fas fa-copy" @click="copy(data.item.account_number)"></i>
                </template>
                <template v-slot:cell(bank_name)="data">
                  {{data.item.bank_name}}
                  <i class="fas fa-copy" @click="copy(data.item.bank_name)"></i>
                </template>
                <template v-slot:cell(min_accept)="data">
                  {{data.item.min_accept | currency}} TL
                </template>
                <template v-slot:cell(max_accept)="data">
                  {{data.item.max_accept | currency}} TL
                </template>
                <template v-slot:cell(distinct_transfer_count)="data">
                  {{data.item.distinct_transfer_count}}
                  /
                  {{ data.item.max_distinct_transfer_count }}
                </template>
                <template v-slot:cell(adding_user)="data">
                  {{ data.item.adding_user.username }}
                </template>
                <template v-slot:cell(sites)="data">
                  {{ sitesDetail({id: data.index, sites: data.item.sites, itemId: data.item.id}) }}
                  <b-badge v-for="(dt, index) in data.item.sites" :key="index">
                    {{sitesName(dt.site_id)}} &nbsp;
                  </b-badge>
                </template>
                <template v-slot:cell(email)="data">
                  <div v-if="data.item.mail">
                    <b-badge v-if="data.item.mail_connect" variant="success" v-b-tooltip:v-b-hover title="Mail Bağlantısı Kuruldu.">
                      <i class="fas fa-check" />
                    </b-badge>
                    <b-badge v-if="!data.item.mail_connect && !data.item.email_err" variant="warning" v-b-tooltip:v-b-hover title="Bağlantı Kuruluyor..">
                      <i class="fas fa-hourglass-half" />
                    </b-badge>
                    <b-badge v-if="!data.item.mail_connect && data.item.email_err" variant="danger" v-b-tooltip:v-b-hover title="Bağlantı Başarısız.">
                      <i class="fas fa-minus" />
                    </b-badge>&nbsp;
                    <b-badge v-if="!data.item.mail_connect && data.item.email_err" variant="info" v-b-tooltip:v-b-hover title="Yeniden Dene">
                      <i class="fas fa-sync" />
                    </b-badge>
                    {{ data.item.email }}   <i class="fas fa-copy" @click="copy(data.item.email)"></i>

                  </div>
                  <div v-else></div>
                </template>
                <template v-slot:cell(total_accept_amount)="data">
                  {{data.item.total_accept_amount | currency}} TL
                  /
                  {{ data.item.transfer_count }} Adt. İşl.
                </template>
                <template v-slot:cell(status)="data">
                  <b-badge v-if="data.item.status" variant="success" @click="changeStatus({status: false, id: data.item.id})">
                    <i class="ion-ios-refresh"></i> AKTİF <i class="class"></i>
                  </b-badge>
                  <b-badge variant="danger" v-else @click="changeStatus({status: true, id: data.item.id})">
                    <i class="ion-ios-refresh"></i> DONDURULDU
                  </b-badge>
                </template>
                <template v-slot:cell(filter)="data">
                  <b-badge v-if="data.item.filter" variant="success">
                    Filtreleme Açık
                  </b-badge>
                  <b-badge v-if="data.item.filter" variant="">
                    {{data.item.keys}}
                  </b-badge>
                  <b-badge v-else variant="primary">
                    Filtreleme kapalı
                  </b-badge>
                </template>
                <template v-slot:cell(edit)="data">
                  <b-button-group>
                    <b-button v-if="data.item.mail" :to="{path: 'mails?email='+data.item.email}" class="btn-sm" variant="primary" v-b-tooltip:v-b-hover title="Yatırım Maillerini Gör"> <i class="ion-md-mail"></i> </b-button>
                    <b-button :to="{path: '/deposits?account_number='+data.item.account_number+'&start_date='+thisMonth.startOfMonth+'&end_date='+thisMonth.endOfMonth}" class="btn-sm" variant="info" v-b-tooltip:v-b-hover title="Yatırımları Gör"> <i class="fas fa-money-bill"></i> </b-button>
                    <b-button @click="editIt(data.item.id)" class="btn-sm" variant="warning" v-b-tooltip:v-b-hover title="Düzenle"> <i class="fas fa-edit"></i> </b-button>
                    <b-button @click="removeIt(data.item.id)" class="btn-sm" variant="danger" v-b-tooltip:v-b-hover title="Hesabı Sil"> <i class="fas fa-trash"></i> </b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row d-print-none">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddBankAccount></AddBankAccount>
    <EditBankAccount :id="editId"></EditBankAccount>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import bankAccountsService from "@/services/bankAccountsService";
import AddBankAccount from "@/components/modals/bank-accounts/AddBankAccount";
import EditBankAccount from "@/components/modals/bank-accounts/EditBankAccount";
import moment from 'moment'
import sitesService from "@/services/sitesService";

export default {
  page: {
    title: "Banka Hesapları",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AddBankAccount, EditBankAccount },
  data() {
    return {
      categories: {
        sites: []
      },
      title: "Banka Hesapları",
      items: [
        {
          text: "Anasayfa",
          to: "/"
        },
        {
          text: "Banka Hesapları",
          active: true
        }
      ],
      name : '',
      fields: [
        {key: 'edit', label: '#', sortable: false },
        {key: 'bank_name', label: 'Banka Adı', sortable: true },
        {key: 'account_name', label: 'İsim Soyisim', sortable: true },
        {key: 'account_number', label: 'IBAN', sortable: true },
        {key: 'sites', label: 'Siteler', sortable: false },
        {key: 'min_accept', label: 'Minimum Yatırım', sortable: true },
        {key: 'max_accept', label: 'Maximum Yatırım', sortable: false },
        {key: 'distinct_transfer_count', label: 'Transfer Limit.', sortable: false },
        {key: 'total_accept_amount', label: 'Aylık Yatırım', sortable: false },
        {key: 'status', label: 'Durum', sortable: false },
        {key: 'filter', label: '(VIP Hesabı) Filtrele', sortable: false },
        {key: 'adding_user', label: 'Ekleyen', sortable: false },

      ],
      id: '',
      editId: '',
      tableData: [],
      totalRows: 0,
      loading: true,
      perPage : 0,
      currentPage: 1,
      status_id: '',
      min_accept: '',
      max_accept: '',
      status: [
        {label: 'Tümü', value: ''},
        {label: 'Aktif Hesaplar', value: true},
        {label: 'Dondurulan Hesaplar', value: false},
      ],
      account_name: '',
      account_number: '',
      email: '',
      refresh: this.$store.getters['getRefresh'],
      mail: null,
      mail_connect: null,
      thisMonth: {
        startOfMonth : moment().startOf('month').format('YYYY-MM-DD'),
        endOfMonth   : moment().endOf('month').format('YYYY-MM-DD')
      },
      sites: [],
      activatedSites: []
    };
  },
  methods: {
    editIt(id) {
      this.editId = id
      setTimeout(() => {
        this.$bvModal.show('editModal')
      }, 300)
    },
    get() {
      this.loading = true
      this.tableData = []

      bankAccountsService.get({panel_two: true, pep_account: false, mefete_account: false, mail_connect: this.mail_connect,mail: this.mail, email: this.email, min_accept: this.min_accept, max_accept: this.max_accept, page: this.currentPage, status: this.status_id.value, key: this.account_name, account_number: this.account_number})
          .then((res) => {
            this.loading = false
            if(res.state){
              this.tableData =  res.data
              this.page = res.page
              this.totalRows = res.rows
              this.perPage = res.perPage
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    changeStatus(item) {
      bankAccountsService.changeStatus({status: item.status, id: item.id})
          .then((res) => {
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Güncelleme başarılı.', message: ''})
              this.get()
            }else {
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    changeFast(item) {
      bankAccountsService.changeFast({status: item.status, id: item.id})
          .then((res) => {
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Güncelleme başarılı.', message: ''})
              this.get()
            }else {
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    changeNextDay(item) {
      bankAccountsService.changeNextDay({status: item.status, id: item.id})
          .then((res) => {
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Güncelleme başarılı.', message: ''})
              this.get()
            }else {
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    removeIt(id){
      this.$swal({
        title: "Hesap tamamen silinecek, emin misiniz?",
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Gönder",
        cancelButtonText: "Vazgeç"
      }).then((result) => {
        if(result.value){
          bankAccountsService.remove({id: id})
              .then((res) => {
                if(res.state){
                  this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Silindi.', message: ''})
                  this.$store.dispatch('getRefresh', {withdrawals: true})
                }else{
                  this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                }
              })
        }
      })
    },
    copy(item){
      let input = document.createElement('textarea');
      input.innerHTML = item;
      document.body.appendChild(input);
      input.select();
      let result = document.execCommand('copy');
      document.body.removeChild(input);
      this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kopyalandı', message: item})
      return result
    },
    getDetail(data){
      bankAccountsService.detail({id: data.id, email: this.email, min_accept: this.min_accept, max_accept: this.max_accept, page: this.currentPage, status: this.status_id.value, key: this.account_name, account_number: this.account_number})
          .then((res) => {
            if(res.state){
              if(res.data.mail_connect)
                this.$store.dispatch('getPlayOpened', true)
              else if(!res.data.mail_connect && res.data.email_err)
                this.$store.dispatch('getPlayDisconnected', true)
              if(res.data.status === false)
                this.$store.dispatch('getPlaySuspend', true)

              if(data.index < 0){
                this.tableData.unshift(res.data)
              }else {
                this.tableData.splice(data.index, 1)
                this.tableData.unshift(res.data)
              }
            }
          })
    },
    getSiteCategories(){
      sitesService.get({})
          .then((res) => {
            this.loading = false
            if(res.state){
              let data = res.data
              this.categories.sites = data
            }
          })
    },
    getSites(){
      sitesService.get({})
          .then((res) => {
            this.loading = false
            if(res.state){
              let data = res.data
              this.sites = data
            }
          })
    },
    sitesDetail(item){
      let sites = []
      let run = () => {
        if(sites.length > 0){
          return sites
        }
        else{
          let find = this.tableData.findIndex(e => e.id === item.itemId)
          this.tableData.splice(find, 1)
        }
      }
      item.sites.map((detail, index, array) => {

        let find = this.activatedSites.findIndex(e => e.id === detail.site_id)
        if(find > -1){
          sites.push(this.activatedSites[find].site_name)
        }

        if(index === array.length -1){
          run()
        }
      })
    },
    removeActivatedSite(item){
      let findIndex = this.activatedSites.findIndex(e => e.id === item.id)
      let s = this.activatedSites[findIndex]
      this.sites.push(s)
      this.activatedSites.splice(findIndex, 1)
    },
    addActivatedSite(item){
      let findIndex = this.sites.findIndex(e => e.id === item.id)
      let s = this.sites[findIndex]
      if(this.activatedSites.length > 0){
        this.sites.push(this.activatedSites[0])
      }
      this.activatedSites = []
      this.activatedSites.push(s)
      this.sites.splice(findIndex, 1)
      this.get()
    },
    sitesName(item){
      let find = this.categories.sites.findIndex(e => e.id === item)
      if(find > -1){
        return this.categories.sites[find].site_name
      }
    }
  },
  created() {
    this.get()
    this.getSites()
    this.getSiteCategories()
  },
  watch: {
    currentPage: function () {
      this.get()
    },
    refresh: function () {
      if(this.refresh){
        this.get()
        this.$store.dispatch('getRefresh', false)
      }
    },
    '$store.getters.getRefresh': function() {
      this.refresh = this.$store.getters.getRefresh
    },
    '$store.getters.newData': function() {
      if(this.$store.getters.newData)
      {
        let id = this.$store.getters.newData.id
        let page = this.$store.getters.newData.page

        if(page === 'bankAccounts' || page === 'account-suspend'){
          let productIndex = this.tableData.findIndex( e=> e.id == id)
          this.getDetail({id: id, index: productIndex})
        }
      }
    },


  }
};
</script>
